import { render, staticRenderFns } from "./HotelDetails.vue?vue&type=template&id=54f9276c&scoped=true"
import script from "./HotelDetails.vue?vue&type=script&lang=js"
export * from "./HotelDetails.vue?vue&type=script&lang=js"
import style0 from "./HotelDetails.vue?vue&type=style&index=0&id=54f9276c&prod&lang=css"
import style1 from "./HotelDetails.vue?vue&type=style&index=1&id=54f9276c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f9276c",
  null
  
)

export default component.exports